import React, { Component } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import moment from 'moment';
import { components } from 'react-select';
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import CardLessDataTableWithSearch from '../../datatables/CardLessDataTableWithSearch';
import MultiSelect from "react-multi-select-component";
import * as Cookies from "es-cookie";
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import '../_schoolActivityManagement.scss';

const CREATE_SCHOOL_EVENT = gql`
  mutation createSchoolEvent($params: CreateSchoolEventInput) {
    createSchoolEvent(params: $params)
  }
`;

const parseDate = (val) => {
  if (!val) return moment.invalid();
  if (/^\d+$/.test(val.toString())) {
    return moment(parseInt(val, 10));
  }
  return moment(val, ["YYYY-MM-DDTHH:mm", "DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm", "YYYY-MM-DD"]);
};


// Custom Dropdown Indicator to match standard styling
const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg">
          <path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
        </svg>
      </components.DropdownIndicator>
    )
  );
};


class HolidaysTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Creation Form Fields
      event_name: "",
      event_type: "",
      description: "",
      event_categorie_id: "",
      event_category_target: "",
      start_time: "",
      end_time: "",
      visible_to_parents: false,
      categoryValue: null,
      selectedClasses: [],
      selectedEmployees: [],
      isUpdateMode: false,
      editId: null,
      isSubmitting: false,
      formErrors: {},

      // History filters
      searchTerm: "",
      filterCategory: "",
      filterDate: "",
      toolbarCategoryValue: null,

      // Events list initialized using dynamic query data
      eventsList: (props.eventsData || []).map(item => ({
        id: item.id,
        title: item.event_name,
        category: item.event_category || "",
        startDate: item.start_time,
        endDate: item.end_time,
        visibility: item.target_name || "All Students",
        description: item.description || "",
        visible_to_parents: item.visible_to_parents === 1,
        event_type: item.event_type,
        event_categorie_id: item.event_categorie_id,
        event_category_target: item.event_category_target
      }))
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eventsData !== this.props.eventsData) {
      this.setState({
        eventsList: (this.props.eventsData || []).map(item => ({
          id: item.id,
          title: item.event_name,
          category: item.event_category || "",
          startDate: item.start_time,
          endDate: item.end_time,
          visibility: item.target_name || "All Students",
          description: item.description || "",
          visible_to_parents: item.visible_to_parents === 1,
          event_type: item.event_type,
          event_categorie_id: item.event_categorie_id,
          event_category_target: item.event_category_target
        }))
      });
    }
  }

  // Get dynamic categories from backend props
  getCategoryOptions = () => {
    const { eventCategories } = this.props;
    if (eventCategories && eventCategories.length > 0) {
      return eventCategories.map(cat => ({
        value: cat.id,
        label: cat.event_category
      }));
    }
    return [];
  }

  // SelectDropDown handlers
  handleCategoryChange = (name, value, selectedOption) => {
    this.setState({
      event_categorie_id: value,
      categoryValue: selectedOption,
      selectedClasses: [],
      selectedEmployees: [],
      formErrors: { ...this.state.formErrors, category: null, classes: null, employees: null }
    });
  }

  handleToolbarCategoryChange = (name, value, selectedOption) => {
    this.setState({
      filterCategory: value === "All" ? "" : value,
      toolbarCategoryValue: selectedOption
    });
  }

  handleEditClick = (row) => {
    const categoryOptions = this.getCategoryOptions();
    const matchedCat = categoryOptions.find(opt => opt.label === row.category || opt.value === row.category) || { value: row.category, label: row.category };

    const classes = this.props.classes || [];
    const classOptions = classes.map(c => ({ value: c.id.toString(), label: `Class ${c.class}` }));
    const targets = (row.event_category_target || "").split(",").map(s => s.trim());
    const selectedClasses = classOptions.filter(opt => targets.includes(opt.value));

    const employees = this.props.employees || [];
    const teacherEmployees = employees.filter(emp => emp.employee_type_id == 3 || emp.employee_type_id == "3");
    const employeesToUse = teacherEmployees.length > 0 ? teacherEmployees : employees;
    const employeeOptions = employeesToUse.map(emp => ({ value: emp.employee_id.toString(), label: emp.employee_name }));
    const selectedEmployees = employeeOptions.filter(opt => targets.includes(opt.value));

    this.setState({
      isUpdateMode: true,
      editId: row.id,
      event_name: row.title || "",
      description: row.description || "",
      start_time: row.startDate ? parseDate(row.startDate).format("YYYY-MM-DD HH:mm") : "",
      end_time: row.endDate ? parseDate(row.endDate).format("YYYY-MM-DD HH:mm") : "",
      visible_to_parents: row.visible_to_parents === true || row.visible_to_parents === "true" || row.visible_to_parents === 1,
      categoryValue: matchedCat,
      event_categorie_id: matchedCat.value,
      selectedClasses,
      selectedEmployees,
      formErrors: {}
    }, () => {
      this.props.history.push("/school-activity-management/holidays/create");
    });
  }

  handleDeleteClick = async (row) => {
    if (window.confirm("Are you sure you want to delete this holiday?")) {

      const params = {
        id: parseInt(row.id) || 0,
        type: "delete",
        event_name: row.title || "",
        event_type: 1,
        description: row.description || "",
        event_categorie_id: parseInt(row.event_categorie_id) || 0,
        event_category_target: row.event_category_target || "",
        start_time: row.startDate ? parseDate(row.startDate).format("YYYY-MM-DD HH:mm") : "",
        end_time: row.endDate ? parseDate(row.endDate).format("YYYY-MM-DD HH:mm") : "",
        visible_to_parents: row.visible_to_parents,
        inserted_by: parseInt(Cookies.get("id") || "1")
      };
      try {
        await this.props.client.mutate({
          mutation: CREATE_SCHOOL_EVENT,
          variables: { params }
        });

        if (this.props.refetchActivityDetails) {
          await this.props.refetchActivityDetails();
        }

        this.setState(prevState => ({
          eventsList: prevState.eventsList.filter(item => item.id !== row.id)
        }));

      } catch (err) {
        console.error("Error deleting event:", err);
        alert("An error occurred while deleting the event.");
      }
    }
  }

  // Save event handler
  handleSaveEvent = async () => {
    const { event_name, start_time, end_time, categoryValue, selectedClasses, selectedEmployees, description, visible_to_parents, isUpdateMode, editId } = this.state;
    const errors = {};

    if (!event_name || !event_name.trim()) {
      errors.event_name = "Holiday title is required";
    }
    if (!categoryValue) {
      errors.category = "Category is required";
    }
    if (!start_time) {
      errors.start_time = "Start date & time is required";
    }
    if (!end_time) {
      errors.end_time = "End date & time is required";
    }
    if (start_time && end_time && parseDate(end_time).isBefore(parseDate(start_time))) {
      errors.end_time = "End date & time cannot be before start date & time";
    }

    const isIndividualClasses = categoryValue && (categoryValue.label === "Individual Classes" || categoryValue.value === "Individual Classes");
    const isAllTeachingStaff = categoryValue && (categoryValue.label === "All Teaching Staff" || categoryValue.value === "All Teaching Staff");

    if (isIndividualClasses && selectedClasses.length === 0) {
      errors.classes = "Please select at least one class";
    }
    if (isAllTeachingStaff && selectedEmployees.length === 0) {
      errors.employees = "Please select at least one employee";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ formErrors: errors });
      return;
    }

    const params = {
      type: isUpdateMode ? "update" : "insert",
      event_name: event_name,
      event_type: 2,
      description: description || "",
      event_categorie_id: parseInt(categoryValue.value) || 0,
      event_category_target: isIndividualClasses
        ? selectedClasses.map(c => c.value).join(",")
        : (isAllTeachingStaff ? selectedEmployees.map(e => e.value).join(",") : ""),
      start_time: parseDate(start_time).format("YYYY-MM-DD HH:mm"),
      end_time: parseDate(end_time).format("YYYY-MM-DD HH:mm"),
      visible_to_parents: visible_to_parents ? 1 : 0,
      inserted_by: parseInt(Cookies.get("id") || "1")
    };

    if (isUpdateMode) {
      params.id = parseInt(editId) || 0;
    }

    try {
      this.setState({ isSubmitting: true });
      await this.props.client.mutate({
        mutation: CREATE_SCHOOL_EVENT,
        variables: { params }
      });

      if (this.props.refetchActivityDetails) {
        await this.props.refetchActivityDetails();
      }

      this.setState({
        event_name: "",
        event_type: "",
        description: "",
        event_categorie_id: "",
        event_category_target: "",
        start_time: "",
        end_time: "",
        visible_to_parents: false,
        categoryValue: null,
        selectedClasses: [],
        selectedEmployees: [],
        formErrors: {},
        isUpdateMode: false,
        editId: null,
        isSubmitting: false
      }, () => {
        this.props.history.push("/school-activity-management/holidays");
      });

    } catch (err) {
      console.error("Mutation error:", err);
      alert("An error occurred while saving the event.");
      this.setState({ isSubmitting: false });
    }
  }

  // Render Event Details Creation form
  renderCreationForm = () => {
    const categoryOptions = this.getCategoryOptions();
    const { formErrors, categoryValue } = this.state;
    const classes = this.props.classes || [];
    const employees = this.props.employees || [];

    const classOptions = (classes && classes.length > 0)
      ? classes.map(c => ({ value: c.id.toString(), label: `Class ${c.class}` }))
      : Array.from({ length: 10 }, (_, i) => ({ value: (i + 1).toString(), label: `Class ${i + 1}` }));

    const teacherEmployees = employees.filter(emp => emp.employee_type_id == 3 || emp.employee_type_id == "3");
    const employeesToUse = teacherEmployees.length > 0 ? teacherEmployees : employees;
    const employeeOptions = (employeesToUse && employeesToUse.length > 0)
      ? employeesToUse.map(emp => ({ value: emp.employee_id.toString(), label: emp.employee_name }))
      : Array.from({ length: 5 }, (_, i) => ({ value: `emp-${i + 1}`, label: `Teacher ${i + 1}` }));

    const isIndividualClasses = categoryValue && (categoryValue.label === "Individual Classes" || categoryValue.value === "Individual Classes");
    const isAllTeachingStaff = categoryValue && (categoryValue.label === "All Teaching Staff" || categoryValue.value === "All Teaching Staff");

    return (
      <div className="sam-form-card">
        <div className="sam-form-section-title">Holiday Details</div>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label>Title of Holiday <span>*</span></label>
              <input
                type="text"
                placeholder="Enter holiday title"
                value={this.state.event_name}
                onChange={(e) => this.setState({ event_name: e.target.value, formErrors: { ...formErrors, event_name: null } })}
              />
              {formErrors.event_name && (
                <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.event_name}</div>
              )}
            </div>

            <div className="form-group">
              <label>Category <span>*</span></label>
              <SelectDropDown
                options={categoryOptions}
                stateData={this.state.categoryValue}
                handleChange={this.handleCategoryChange}
                name="category"
                placeholderName="Select Category"
                dropdownIndicator={{ DropdownIndicator }}
              />
              {formErrors.category && (
                <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.category}</div>
              )}
            </div>

            <div className="form-group">
              <label>Start Date & Time <span>*</span></label>
              <input
                type="datetime-local"
                value={this.state.start_time ? (parseDate(this.state.start_time).isValid() ? parseDate(this.state.start_time).format("YYYY-MM-DDTHH:mm") : this.state.start_time) : ""}
                onChange={(e) => this.setState({ start_time: e.target.value, formErrors: { ...formErrors, start_time: null } })}
              />
              {formErrors.start_time && (
                <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.start_time}</div>
              )}
            </div>

            <div className="form-group">
              <label>End Date & Time <span>*</span></label>
              <input
                type="datetime-local"
                value={this.state.end_time ? (parseDate(this.state.end_time).isValid() ? parseDate(this.state.end_time).format("YYYY-MM-DDTHH:mm") : this.state.end_time) : ""}
                onChange={(e) => this.setState({ end_time: e.target.value, formErrors: { ...formErrors, end_time: null } })}
              />
              {formErrors.end_time && (
                <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.end_time}</div>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>Description</label>
              <textarea
                rows={5}
                placeholder="Enter event description"
                value={this.state.description}
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </div>

            {isIndividualClasses && (
              <div className="form-group">
                <label>Select Classes <span>*</span></label>
                <div className={formErrors.classes ? "is-err" : ""}>
                  <MultiSelect
                    options={classOptions}
                    value={this.state.selectedClasses}
                    onChange={(selected) => this.setState({ selectedClasses: selected, formErrors: { ...formErrors, classes: null } })}
                    labelledBy="Select Classes"
                    overrideStrings={{ selectSomeItems: "Select Classes" }}
                    isLoading={this.props.isLoading}
                  />
                </div>
                {formErrors.classes && (
                  <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.classes}</div>
                )}
              </div>
            )}

            {isAllTeachingStaff && (
              <div className="form-group">
                <label>Select Employees <span>*</span></label>
                <div className={formErrors.employees ? "is-err" : ""}>
                  <MultiSelect
                    options={employeeOptions}
                    value={this.state.selectedEmployees}
                    onChange={(selected) => this.setState({ selectedEmployees: selected, formErrors: { ...formErrors, employees: null } })}
                    labelledBy="Select Employees"
                    overrideStrings={{ selectSomeItems: "Select Employees" }}
                    isLoading={this.props.isLoading}
                  />
                </div>
                {formErrors.employees && (
                  <div className="text-danger small mt-1" style={{ fontSize: "11px" }}>{formErrors.employees}</div>
                )}
              </div>
            )}

            <div className="form-group mt-3">
              <div className="checkbox-group">
                <label className="form-check m-0">
                  <input
                    type="checkbox"
                    checked={this.state.visible_to_parents}
                    onChange={(e) => this.setState({ visible_to_parents: e.target.checked })}
                    style={{ marginRight: "8px" }}
                  />
                  Send Notification to Parents
                </label>
              </div>
            </div>
          </Col>
        </Row>

        <div className="sam-form-footer">
          <button
            className="sam-btn sam-btn-outline"
            onClick={() => this.props.history.push("/school-activity-management/holidays")}
          >
            Cancel
          </button>
          <button
            className="sam-btn sam-btn-primary"
            onClick={this.handleSaveEvent}
            disabled={this.state.isSubmitting}
          >
            {this.state.isSubmitting && (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            )}
            Save Holiday
          </button>
        </div>
      </div>
    );
  }

  // Render Event History table list view
  renderHistoryList = () => {
    const { searchTerm, filterCategory, eventsList } = this.state;

    // Filter local events list
    const filteredEvents = eventsList.filter((event) => {
      const matchesSearch =
        !searchTerm ||
        (event.title && event.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.description && event.description.toLowerCase().includes(searchTerm.toLowerCase()));

      const matchesCategory =
        !filterCategory ||
        (event.event_categorie_id && event.event_categorie_id.toString() === filterCategory.toString());

      const matchesType = event.event_type === 2;

      return matchesSearch && matchesCategory && matchesType;
    });

    // Setup options for toolbar dropdown
    const toolbarCategoryOptions = [
      { value: "All", label: "All Categories" },
      ...this.getCategoryOptions()
    ];

    // CardLessDataTableWithSearch columns
    const particlecolumns = [
      {
        dataField: 'title',
        text: 'EVENT NAME',
        sort: true,
        formatter: (cellContent, row) => {
          let iconClass = "fal fa-calendar-alt";
          let bgLight = "#eff6ff";
          let iconColor = "#2563eb";

          const cat = (row.category || "").toLowerCase();
          if (cat.includes("sport")) {
            iconClass = "fal fa-trophy";
            bgLight = "#f5f3ff";
            iconColor = "#7c3aed";
          } else if (cat.includes("competition")) {
            iconClass = "fal fa-award";
            bgLight = "#ecfdf5";
            iconColor = "#059669";
          } else if (cat.includes("meeting")) {
            iconClass = "fal fa-users";
            bgLight = "#fff7ed";
            iconColor = "#ea580c";
          } else if (cat.includes("cultural") || cat.includes("music")) {
            iconClass = "fal fa-music";
            bgLight = "#fdf2f8";
            iconColor = "#db2777";
          }

          return (
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "8px",
                  backgroundColor: bgLight,
                  color: iconColor,
                  marginRight: "12px",
                  flexShrink: 0
                }}
              >
                <i className={iconClass} style={{ fontSize: "16px" }} />
              </div>
              <div>
                <div className="fw-bold" style={{ color: "#1e293b", fontSize: "13.5px" }}>
                  {row.title}
                </div>
                <div className="text-secondary small" style={{ fontSize: "11.5px" }}>
                  {row.category}
                </div>
              </div>
            </div>
          );
        }
      },
      {
        dataField: 'visibility',
        text: 'CATEGORY',
        sort: true,
        formatter: (cellContent, row) => {
          let badgeClass = "sam-badge-sports";
          const vis = (row.visibility || "").toLowerCase();
          if (vis.includes("class")) {
            badgeClass = "sam-badge-competition";
          } else if (vis.includes("parent")) {
            badgeClass = "sam-badge-meeting";
          }
          return (
            <span className={`sam-badge ${badgeClass}`}>
              {row.visibility}
            </span>
          );
        }
      },
      {
        dataField: 'startDate',
        text: 'START DATE',
        sort: true,
        formatter: (cellContent, row) => {
          const m = parseDate(row.startDate);
          return (
            <div>
              <div className="fw-semibold" style={{ color: "#334155" }}>
                {m.isValid() ? m.format("DD MMM, YYYY") : row.startDate}
              </div>
              <div className="text-muted small" style={{ fontSize: "11px" }}>
                {m.isValid() ? m.format("hh:mm A") : ""}
              </div>
            </div>
          );
        }
      },
      {
        dataField: 'endDate',
        text: 'END DATE',
        sort: true,
        formatter: (cellContent, row) => {
          const m = parseDate(row.endDate);
          return (
            <div>
              <div className="fw-semibold" style={{ color: "#334155" }}>
                {m.isValid() ? m.format("DD MMM, YYYY") : row.endDate}
              </div>
              <div className="text-muted small" style={{ fontSize: "11px" }}>
                {m.isValid() ? m.format("hh:mm A") : ""}
              </div>
            </div>
          );
        }
      },
      {
        dataField: 'visible_to_parents',
        text: 'VISIBILITY',
        sort: true,
        align: 'center',
        headerAlign: 'center',
        formatter: (cellContent, row) => {
          const isVisible = row.visible_to_parents === true || row.visible_to_parents === "true" || (row.notifications && row.notifications.length > 0);
          return (
            <div className="d-flex align-items-center justify-content-center text-secondary" style={{ fontSize: "13px" }}>
              <i className="fal fa-eye" style={{ marginRight: "6px", color: "#64748b" }} />
              <span>{isVisible ? "Visible to Parents" : "Not Visible to Parents"}</span>
            </div>
          );
        }
      },
      {
        dataField: 'actions',
        text: 'ACTIONS',
        isDummyField: true,
        formatter: (cellContent, row) => {
          return (
            <div className="d-flex align-items-center">
              <button
                className="sam-action-btn"
                title="Edit Event"
                onClick={() => this.handleEditClick(row)}
              >
                <i className="fal fa-pencil" />
              </button>
              <button
                className="sam-action-btn text-danger"
                title="Delete Event"
                onClick={() => this.handleDeleteClick(row)}
              >
                <i className="fal fa-trash" />
              </button>
            </div>
          );
        }
      }
    ];

    return (
      <div>
        {/* Custom filters toolbar */}
        <div className="sam-table-toolbar">
          <div className="sam-toolbar-left">
            <div className="sam-search-container">
              <i className="fal fa-search" />
              <input
                type="text"
                placeholder="Search events..."
                value={this.state.searchTerm}
                onChange={(e) => this.setState({ searchTerm: e.target.value })}
              />
            </div>

            <div style={{ width: "180px" }}>
              <SelectDropDown
                options={toolbarCategoryOptions}
                stateData={this.state.toolbarCategoryValue || { value: "All", label: "All Categories" }}
                handleChange={this.handleToolbarCategoryChange}
                name="toolbarCategory"
                placeholderName="All Categories"
                dropdownIndicator={{ DropdownIndicator }}
              />
            </div>
          </div>

          <button
            className="sam-btn sam-btn-primary"
            onClick={() => {
              this.setState({
                event_name: "",
                event_type: "",
                description: "",
                event_categorie_id: "",
                event_category_target: "",
                start_time: "",
                end_time: "",
                visible_to_parents: false,
                categoryValue: null,
                selectedClasses: [],
                selectedEmployees: [],
                isUpdateMode: false,
                editId: null,
                formErrors: {},
                // History filters
                searchTerm: "",
                filterCategory: "",
                filterDate: "",
                toolbarCategoryValue: null,
              })
              this.props.history.push("/school-activity-management/holidays/create")
            }}
          >
            <i className="fal fa-plus" /> Create Holiday
          </button>
        </div>

        {/* CardLessDataTableWithSearch */}
        <div className="sam-table-card">
          {filteredEvents.length > 0 ? (
            <CardLessDataTableWithSearch
              parentData={filteredEvents}
              particlecolumns={particlecolumns}
              searchBar={false}
              placeholder="Search events..."
              name="events_history"
            />
          ) : (
            <div className="text-center py-5 text-muted border rounded bg-white" style={{ fontSize: "14px", fontWeight: "500" }}>
              No data found
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { action } = this.props;
    console.log("action", this.props);

    return (
      <div className="sam-root p-0" style={{ background: "transparent", minHeight: "auto" }}>
        {action === "create" ? this.renderCreationForm() : this.renderHistoryList()}
      </div>
    );
  }
}

export default withApollo(HolidaysTab);
